<div class="bp-landing">

  <header class="bp-nav">
    <a class="bp-nav__brand" routerLink="/">
      <img src="assets/img/boothpilot/boothpilot-lockup.svg" alt="BoothPilot">
    </a>
    <div class="bp-nav__end">
      <app-legal-lang-toggle [lang]="lang" (langChange)="lang = $event"></app-legal-lang-toggle>
      <a class="bp-btn bp-btn--dark" routerLink="/user/login">{{ lang === 'fr' ? 'Se connecter' : 'Sign in' }}</a>
    </div>
  </header>

  @if (lang === 'en') {
    <section class="bp-hero">
      <h1 class="bp-hero__title">Every game, captured. No one behind the camera.</h1>
      <p class="bp-hero__lead">
        BoothPilot plans your schedule, records the game, and gets the footage where it needs to go —
        automatically.
      </p>
      <p class="bp-hero__note">
        * BoothPilot is currently in closed beta and available by invitation only. If your club is
        taking part, sign in above.
      </p>
    </section>

    <section class="bp-intro">
      <p class="bp-intro__body">
        BoothPilot is video software for sports teams that don't have anyone free to run a camera. Coaches
        and team managers set up their season once; from there the platform records each game, streams it
        live for the families who can't be in the stands, and gets the footage to wherever the team reviews
        it.
      </p>
    </section>

    <section class="bp-features">
      <div class="bp-feature">
        <h2 class="bp-feature__title">Auto-record</h2>
        <p class="bp-feature__body">One camera, mounted once. It follows the play and records the whole game.</p>
      </div>
      <div class="bp-feature">
        <h2 class="bp-feature__title">Auto-upload</h2>
        <p class="bp-feature__body">Footage reaches your coaching tool before you leave the booth.</p>
      </div>
      <div class="bp-feature">
        <h2 class="bp-feature__title">Live broadcast</h2>
        <p class="bp-feature__body">Stream the game live to parents and fans, no operator required.</p>
      </div>
    </section>

    <section class="bp-more">
      <p class="bp-more__body">
        BoothPilot comes as two applications: BoothPilot on the web, and BoothPilot Replay on mobile for
        cloud-based sideline replays.
      </p>
      <a class="bp-btn bp-btn--dark" routerLink="/products">See both applications</a>
    </section>
  } @else {
    <section class="bp-hero">
      <h1 class="bp-hero__title">Chaque match filmé. Personne derrière la caméra.</h1>
      <p class="bp-hero__lead">
        BoothPilot planifie votre calendrier, filme le match et achemine les séquences là où elles
        doivent aller — automatiquement.
      </p>
      <p class="bp-hero__note">
        * BoothPilot est actuellement en bêta fermée, accessible sur invitation seulement. Si votre
        club y participe, connectez-vous ci-dessus.
      </p>
    </section>

    <section class="bp-intro">
      <p class="bp-intro__body">
        BoothPilot est un logiciel vidéo pour les équipes sportives qui n'ont personne de disponible pour
        tenir la caméra. Les entraîneurs et les gérants d'équipe configurent leur saison une seule fois;
        la plateforme filme ensuite chaque match, le diffuse en direct pour les familles qui ne peuvent pas
        être dans les gradins, et achemine les séquences là où l'équipe les visionne.
      </p>
    </section>

    <section class="bp-features">
      <div class="bp-feature">
        <h2 class="bp-feature__title">Captation automatique</h2>
        <p class="bp-feature__body">Une caméra, installée une seule fois. Elle suit le jeu et filme tout le match.</p>
      </div>
      <div class="bp-feature">
        <h2 class="bp-feature__title">Téléversement automatique</h2>
        <p class="bp-feature__body">Les séquences parviennent à votre outil d'entraînement avant que vous quittiez la passerelle.</p>
      </div>
      <div class="bp-feature">
        <h2 class="bp-feature__title">Diffusion en direct</h2>
        <p class="bp-feature__body">Diffusez le match en direct aux parents et aux partisans, sans opérateur.</p>
      </div>
    </section>

    <section class="bp-more">
      <p class="bp-more__body">
        BoothPilot se décline en deux applications : BoothPilot sur le Web, et BoothPilot Replay sur mobile
        pour la reprise vidéo en nuage au bord du terrain.
      </p>
      <a class="bp-btn bp-btn--dark" routerLink="/products" [queryParams]="{ lang: 'fr' }">Voir les deux
        applications</a>
    </section>
  }

  <footer class="bp-footer">
    <span>© 2026 BoothPilot — Laurent Chicoine Productions</span>
    <span class="bp-footer__links">
      @if (lang === 'en') {
        <a routerLink="/products">Applications</a>
        <a routerLink="/privacy">Privacy Policy</a>
        <a routerLink="/tos">Terms of Service</a>
        <a href="mailto:hostmaster&#64;boothpilot.com">Contact</a>
      } @else {
        <a routerLink="/products" [queryParams]="{ lang: 'fr' }">Applications</a>
        <a routerLink="/privacy" [queryParams]="{ lang: 'fr' }">Politique de confidentialité</a>
        <a routerLink="/tos" [queryParams]="{ lang: 'fr' }">Conditions d'utilisation</a>
        <a href="mailto:hostmaster&#64;boothpilot.com">Nous joindre</a>
      }
    </span>
  </footer>

</div>
